export const featureFlags = {
    usePendingStatus: true,
    useRemoteSubmissions: true,
};
